import { render, staticRenderFns } from "./FieldTaskSortOrder.vue?vue&type=template&id=03021127&scoped=true"
import script from "./FieldTaskSortOrder.vue?vue&type=script&lang=js"
export * from "./FieldTaskSortOrder.vue?vue&type=script&lang=js"
import style0 from "./FieldTaskSortOrder.vue?vue&type=style&index=0&id=03021127&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03021127",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03021127')) {
      api.createRecord('03021127', component.options)
    } else {
      api.reload('03021127', component.options)
    }
    module.hot.accept("./FieldTaskSortOrder.vue?vue&type=template&id=03021127&scoped=true", function () {
      api.rerender('03021127', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fields/FieldTaskSortOrder.vue"
export default component.exports